import React from 'react';

export type LandingProcessStep = {
  step: number;
  icon: React.ReactNode;
  title: string;
  body: string;
};

export type LandingProcessStepsProps = {
  steps: LandingProcessStep[];
};

const LandingProcessSteps: React.FC<LandingProcessStepsProps> = ({ steps }) => (
  <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
    {steps.map((s) => (
      <div key={s.step} className="flex flex-col border border-slate-800 bg-slate-900/35 p-6 md:p-8">
        <div className="mb-4 flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-purple-500/30 bg-purple-600/25 text-sm font-bold text-purple-200">
            {s.step}
          </span>
          <span className="shrink-0 text-purple-400">{s.icon}</span>
        </div>
        <h3 className="mb-2 text-lg font-semibold text-white">{s.title}</h3>
        <p className="flex-grow text-sm leading-relaxed text-slate-400">{s.body}</p>
      </div>
    ))}
  </div>
);

export default LandingProcessSteps;
